import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function TrackedChangesEmptyIcon(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
}): JSX.Element {
  return (
    <SvgIcon
      classes={props.classes}
      style={{ display: 'block', height: 40, width: 40 }}
      viewBox="0 0 40 40"
    >
      <g fill="none" fillRule="evenodd">
        <g fill={IconColors.LightGray} fillRule="nonzero">
          <g>
            <g>
              <path d="M34.28 28.238c.136.136.22.323.22.53 0 .207-.084.395-.22.53l-3.75 3.75c-.293.294-.767.294-1.06 0-.293-.292-.293-.767 0-1.06l2.47-2.47h-8.19c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75h8.19l-2.47-2.47c-.293-.292-.293-.767 0-1.06.293-.293.767-.293 1.06 0l3.75 3.75zm5.22.53c0 5.937-4.813 10.75-10.75 10.75S18 34.705 18 28.768s4.813-10.75 10.75-10.75 10.75 4.813 10.75 10.75zm-1.5 0c0-5.108-4.141-9.25-9.25-9.25s-9.25 4.142-9.25 9.25c0 5.109 4.141 9.25 9.25 9.25S38 33.877 38 28.768zm-29.25-10.5c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75h8.75c.414 0 .75.336.75.75 0 .415-.336.75-.75.75H8.75zm0 6.25c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75h5c.414 0 .75.336.75.75 0 .415-.336.75-.75.75h-5zm0 6.25c-.414 0-.75-.335-.75-.75 0-.414.336-.75.75-.75h5c.414 0 .75.336.75.75 0 .415-.336.75-.75.75h-5zm20-24c1.795 0 3.25 1.455 3.25 3.25v3.75c0 .415-.336.75-.75.75s-.75-.335-.75-.75v-3.75c0-.966-.784-1.75-1.75-1.75H22.5c-.414 0-.75-.335-.75-.75 0-3.037-2.462-5.5-5.5-5.5s-5.5 2.463-5.5 5.5c0 .415-.336.75-.75.75H3.75c-.966 0-1.75.784-1.75 1.75v26.25c0 .967.784 1.75 1.75 1.75h12.5c.414 0 .75.336.75.75 0 .415-.336.75-.75.75H3.75c-1.795 0-3.25-1.455-3.25-3.25v-26.25c0-1.795 1.455-3.25 3.25-3.25h5.54c.374-3.513 3.347-6.25 6.96-6.25s6.586 2.737 6.96 6.25h5.54zm-11.125.125c0 .76-.616 1.375-1.375 1.375-.76 0-1.375-.615-1.375-1.375s.616-1.375 1.375-1.375c.76 0 1.375.616 1.375 1.375z" />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
